import { useMutation } from '@tanstack/react-query';
import config from '../../../../../../../../../../../config';

async function querySummarize(sessionId: string): Promise<globalThis.ReadableStreamDefaultReader<Uint8Array>> {
  const response = await fetch(`https://${config.ContentGeneration.StreamingUrl}/summarize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ sessionId }),
    credentials: 'include',
  });

  const reader = response.body?.getReader();
  if (!reader) {
    throw new Error('Failed to get reader from the streaming response');
  }

  return reader;
}

export default function useQuerySummarizeMutation() {
  return useMutation<globalThis.ReadableStreamDefaultReader<Uint8Array>, Error, { sessionId: string }>(
    ['querySummarize'],
    ({ sessionId }) => querySummarize(sessionId),
  );
}
